module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am1.8bf69f25.jpg";